import angular from 'angular';
import uiRouter from 'angular-ui-router';
import duScroll from 'angular-scroll';
import Pages from './pages/pages';
import Components from './components/components';
import AppComponent from './app.component';
import Directives from './directives/dataMappingToggle';
import DonutChart from './components/adpDonutChart/donutChart';
import AdpSelectize from './components/adpTypeahead/adpSelectize';
// import 'normalize.css';

angular.module('app', [
    uiRouter,
    duScroll,
    Pages,
    Components,
    Directives,
    DonutChart,
    AdpSelectize
  ])
  .config(($locationProvider) => {
    "ngInject";
    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(false);
  })

  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./src/app/app.js